import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthRequestModel, UserModel } from '@tsin-core/models/auth.model';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';
import { ConfigService } from '@tsin-core/services/common/config.service';

@Injectable({
    providedIn: 'root'
})

// The authentication service
export class AuthService {
    // Inject the http client into auth service
    http: HttpClient = inject(HttpClient);
    configService: ConfigService = inject(ConfigService);

    private get apiBaseUrl(): string {
      return this.configService.getApiUrl() || environment.apiBaseUrl;
    }

    // Method for endpoint to validate the user and return a token
    validate(credentials: AuthRequestModel) {
        return this.http.post(`${this.apiBaseUrl}/auth/authenticate-profiile`, credentials);
    }

    validateToken(payload: { token: string; refreshToken: string }): Observable<UserModel> {
      return this.http.get<UserModel>(`${this.apiBaseUrl}/auth/me`, {
        headers: {
          "Authorization": `Bearer ${payload.token}`
        }
      });
    }

   refreshToken(payload: { refreshToken: string }): Observable<{ token: string; refreshToken: string }> {
        return this.http.post<{ token: string; refreshToken: string }>(`${this.apiBaseUrl}/auth/refresh`, payload);
    }

    // Method for endpoint to logout a user from the server
    logout() {
        return this.http.delete(`${this.apiBaseUrl}/auth/authenticate-profiile`);
    }

    signUpWorkWithUs(payload: {
        firstName: string;
        lastName: string;
        email: string;
        office: string;
        role: string;
        gender: string;
        dateOfBirth: string;
        password: string;
    }) {
        return this.http.post(`${this.apiBaseUrl}/auth/signup`, payload);
    }
}
